module.exports = __webpack_public_path__ + "static/media/wheeledSportsItem.67c9a13a.svg";